/*
 * Marquee announcement bar (sections/cozykids-header.liquid)
 *
 * The section authors the merchant's blocks exactly once. This fills the track
 * to fit:
 *
 *   1. repeat the authored blocks until one group is wider than the bar, so the
 *      halfway reset never exposes an empty stretch on wide screens;
 *   2. clone that group once, so the track is two identical halves and the CSS
 *      translateX(-50%) lands precisely one group along — an invisible seam;
 *   3. derive the duration from the group width, so the bar scrolls at a fixed
 *      pixels-per-second everywhere rather than crawling on mobile and racing
 *      on a 4K display.
 *
 * Only the authored blocks stay in the accessibility tree and tab order; every
 * generated copy is inert. The animation is gated on .is-ready, so if this
 * never runs the bar degrades to a static strip rather than a broken loop.
 */
(function () {
  'use strict';

  var DEFAULT_SPEED = 60; // px per second

  function fill(marquee) {
    var track = marquee.querySelector('.cozy-marquee__track');
    if (!track) return;

    var group = track.querySelector('.cozy-marquee__group');
    if (!group) return;

    // Stash the authored markup on first run; every rebuild starts from it.
    if (typeof marquee._cozySource !== 'string') {
      marquee._cozySource = group.innerHTML;
      marquee._cozyCount = group.querySelectorAll('.cozy-marquee__item').length;
    }
    if (!marquee._cozyCount) return;

    marquee.classList.remove('is-ready');

    // Drop generated clones and restore the authored blocks.
    while (track.children.length > 1) {
      track.removeChild(track.lastChild);
    }
    group.innerHTML = marquee._cozySource;
    group.removeAttribute('aria-hidden');

    var unitWidth = group.scrollWidth;
    var barWidth = marquee.clientWidth;
    if (!unitWidth || !barWidth) return;

    // +1 so the group always overhangs the bar rather than matching it exactly.
    var reps = Math.max(1, Math.ceil(barWidth / unitWidth) + 1);

    var html = '';
    for (var r = 0; r < reps; r++) html += marquee._cozySource;
    group.innerHTML = html;

    // Past the first authored pass, the text is decoration — hide the repeats
    // from screen readers and keep them out of the tab order.
    var items = group.querySelectorAll('.cozy-marquee__item');
    for (var i = marquee._cozyCount; i < items.length; i++) {
      items[i].setAttribute('aria-hidden', 'true');
      if (items[i].tagName === 'A') items[i].setAttribute('tabindex', '-1');
    }

    var clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    var cloneLinks = clone.querySelectorAll('a.cozy-marquee__item');
    for (var j = 0; j < cloneLinks.length; j++) {
      cloneLinks[j].setAttribute('tabindex', '-1');
    }
    track.appendChild(clone);

    var speed = parseFloat(marquee.getAttribute('data-speed')) || DEFAULT_SPEED;
    var distance = group.scrollWidth; // one group == one loop
    marquee.style.setProperty('--cozy-marquee-speed', (distance / speed) + 's');

    marquee.classList.add('is-ready');
  }

  function fillAll() {
    var bars = document.querySelectorAll('.cozy-marquee');
    for (var i = 0; i < bars.length; i++) fill(bars[i]);
  }

  var pending;
  function onResize() {
    clearTimeout(pending);
    pending = setTimeout(fillAll, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillAll);
  } else {
    fillAll();
  }

  window.addEventListener('resize', onResize);

  // Webfonts land after first paint and change the measured width.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fillAll);
  }

  // Theme editor: re-measure when the merchant edits the header. The section is
  // re-rendered from scratch, so the cached authored markup must be dropped.
  document.addEventListener('shopify:section:load', function (e) {
    var bars = e.target.querySelectorAll('.cozy-marquee');
    for (var i = 0; i < bars.length; i++) bars[i]._cozySource = undefined;
    fillAll();
  });
})();
